const Api = {
    '/api/sample-order/set-audit-conf': 1, // 样品规则
    '/api/team-conf/set-product-promotion': 1, // 商品规则-商品自动延长推广
    '/api/team-conf/set-product-duplicate': 1, // 商品规则-招商撞单审核
    '/api/team-conf/circulation-config': 1, // 达人规则-设置达人跟进

}

export default{
    Api
}